import { ItemOrderSchemaType } from './order.schema';

export type SteelItemPayload = Record<string, unknown> & {
  quantity: number;
  subItems: ItemOrderSchemaType[];
  isSaved?: boolean;
};

export const mapSteelItems = (items: ItemOrderSchemaType[] | undefined): SteelItemPayload[] => {
  if (!items || !Array.isArray(items)) return [];

  return items.map((item) => {
    const savedSubItems = Array.isArray(item.subItems)
      ? item.subItems.filter((sub: ItemOrderSchemaType) => sub.isSaved)
      : [];

    // Cabeçalho é a origem da quantidade (spec 04); blocos por tipo são fallback de pedidos legados.
    const headerQuantity =
      typeof item.quantity === 'number' && Number.isFinite(item.quantity) ? item.quantity : undefined;

    let blockQuantity = 0;
    if (item.itemType === 'MATERIAL') {
      blockQuantity = (typeof item.feedstock?.quantidade === 'number') ? item.feedstock.quantidade : 0;
    } else if (item.itemType === 'PRODUCT') {
      blockQuantity = (typeof item.finalProduct?.quantidade === 'number') ? item.finalProduct.quantidade : 0;
    } else if (item.itemType === 'RESOURCE') {
      blockQuantity = (typeof item.resource?.quantidade === 'number') ? item.resource.quantidade : 0;
    } else if (item.itemType === 'SERVICE') {
      blockQuantity = (typeof item.stage?.quantidade === 'number') ? item.stage.quantidade : 0;
    }

    const quantity = headerQuantity ?? blockQuantity;

    let filteredRequestedProduct: any = undefined;
    if (item.requestedProduct && typeof item.requestedProduct === 'object') {
      const filtered: any = {};
      if ('id' in item.requestedProduct) filtered.id = item.requestedProduct.id;
      if ('name' in item.requestedProduct) filtered.name = item.requestedProduct.name;
      filteredRequestedProduct = Object.keys(filtered).length > 0 ? filtered : undefined;
    }

    let itemWithoutRequestedOrOffered = item;
    if (item.itemType === 'MATERIAL') {
      const { requestedProductMaterial, offeredProductMaterial, ...rest } = item;
      itemWithoutRequestedOrOffered = rest;
    } else {
      const { requestedProduct: _omitRequestedProduct, requestedProductMaterial: _omitRequestedProductMaterial, ...rest } = item;
      itemWithoutRequestedOrOffered = rest;
    }

    const shouldSendRequestedProductMaterial = item.itemType !== 'MATERIAL' || savedSubItems.length > 0;
    const shouldSendRequestedProduct = item.itemType !== 'MATERIAL' || (savedSubItems.length > 0 && filteredRequestedProduct);

    return {
      ...itemWithoutRequestedOrOffered,
      ...(item.feedstock ? { feedstock: item.feedstock } : {}),
      ...(shouldSendRequestedProductMaterial && item.requestedProductMaterial ? { requestedProductMaterial: item.requestedProductMaterial } : {}),
      ...(shouldSendRequestedProduct && filteredRequestedProduct ? { requestedProduct: filteredRequestedProduct } : {}),
      quantity,
      subItems: savedSubItems,
    };
  });
};

export const buildSteelItemsPayload = (items: ItemOrderSchemaType[] | undefined): SteelItemPayload[] =>
  mapSteelItems(items).filter((item) => item.isSaved === true);
